import { PrivatePayrollAuctionRedirect } from './Redirect';
import { PrivatePayrollAuctionLoading } from './Loading';
import { PrivatePayrollAuctionLogin } from './Login';
import { PrivatePayrollAuctionEnrichPersonalData } from './EnrichPersonalData';
import { PrivatePayrollAuctionOTP } from './OTP';
import { PrivatePayrollAuctionResumeOperation } from './ResumeOperation';
import { PrivatePayrollAuctionPersonalDocument } from './PersonalDocument';
import { PrivatePayrollAuctionSignedPage } from './SignedPage';
import { PrivatePayrollAuctionFaceRecognition } from './FaceRecognition';
import { PrivatePayrollAuctionDeviceScan } from './DeviceScan';
import { PrivatePayrollAuctionLendingAnalysis } from './LendingAnalysis';
import { PrivatePayrollAuctionLendingReproved } from './LendingReproved';
import { PrivatePayrollAuctionAwaitingEnvelopeSubmit } from './AwaitingEnvelopeSubmit';

export const PrivatePayrollAuctionTheme = {
    Redirect: PrivatePayrollAuctionRedirect,
    Loading: PrivatePayrollAuctionLoading,
    Login: PrivatePayrollAuctionLogin,
    EnrichPersonalData: PrivatePayrollAuctionEnrichPersonalData,
    OTP: PrivatePayrollAuctionOTP,
    ResumeOperation: PrivatePayrollAuctionResumeOperation,
    PersonalDocument: PrivatePayrollAuctionPersonalDocument,
    SignedPage: PrivatePayrollAuctionSignedPage,
    FaceRecognition: PrivatePayrollAuctionFaceRecognition,
    DeviceScan: PrivatePayrollAuctionDeviceScan,
    LendingAnalysis: PrivatePayrollAuctionLendingAnalysis,
    LendingReproved: PrivatePayrollAuctionLendingReproved,
    AwaitingEnvelopeSubmit: PrivatePayrollAuctionAwaitingEnvelopeSubmit,
} as const;
